import { SliderTranslateStrings } from '../../gzSlider/types';

export enum RangeSliderEvents {
  CHANGE_CONFIRMED = 'rangeSliderConfirmed',
}

export interface RangeSliderTranslateStrings extends SliderTranslateStrings {
  confirmButton: string;
  cancelButton: string;
}
